import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { Observable } from 'rxjs';
import { APIS } from '../../common/constants';

export interface SizeChartInfo {
  productCode: string;
  categoryName: string;
  createdOn: string | null;
  latestVersion: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class SizeChartService {

  constructor(private httpService: HttpService) {
  }

  getSizeChartInfo(productId: string): Observable<SizeChartInfo> {
    return this.httpService.getData(APIS.SIZE_CHARTS.INFO + `/${productId}`);
  }

  createSizeChartFromFile(productId: string, formData: FormData): Observable<any> {
    // formData.append('productId', productId);
    return this.httpService.postData(APIS.SIZE_CHARTS.IMPORT_FILE + `/${productId}`, formData);
  }

}
